import { api } from "@/plugins/api";

const state = {
  groups: [],
};

const getters = {
  getAllGroups: (state) => state.groups,

  getGroupById: (state) => (id) =>
    state.groups.filter((group) => group.id === id),
};

const actions = {
  async fetchAllGroups({ commit }) {
    try {
      const response = await api.get("/groups");
      const groups = response.data.data;
      commit("setGroups", groups);
      //return { status: response.status, msg: response.data.message };
      return true;
    } catch (error) {
      //return { status: error.response.status, msg: error.message };
      return false;
    }
  },
  async addGroup({ commit }, group) {
    try {
      //console.log("passed data", group);
      const response = await api.post("/groups", group);
      //console.log("response", response);
      commit("addGroup", response.data.data);
      return true;
    } catch (error) {
      return false;
    }
  },
  async updateGroup({ commit }, group) {
    try {
      const id = group.id;
      //console.log("passed data", group);
      group._method = "put";
      const response = await api.post(`/groups/${id}`, group);
      //console.log("updated", response.data);
      commit("updateGroup", response.data.data);
      return true;
    } catch (error) {
      //console.log("error", error.message);
      return false;
    }
  },
  async deleteGroup({ commit }, id) {
    try {
      //const response = await api.delete(`/groups/${id}`);
      const response = await api.delete(`/groups/${id}`);
      console.log("response", response);
      if (response) {
        commit("removeGroup", id);
      }
      //return response.data.message;
      return true;
    } catch (error) {
      //console.log("response", error);
      //return error.message;
      return false;
    }
  },
};

const mutations = {
  setGroups(state, groups) {
    state.groups = groups;
    //console.log("mu", state.groups);
  },
  addGroup(state, group) {
    //console.log("uses is:", group);
    state.groups.unshift(group);
    //console.log("uses updated:", state.groups);
  },
  removeGroup(state, id) {
    const index = state.groups.findIndex((group) => group.id == id);
    if (index !== -1) {
      state.groups.splice(index, 1);
    }
  },
  updateGroup(state, group) {
    const id = group.id;
    const index = state.groups.findIndex((group) => group.id == id);
    if (index !== -1) {
      state.groups[index] = group;
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
